import { useEffect, useRef, useState } from "react";
import useSWR from "swr";
import { Globe, ChevronDown, Check } from "lucide-react";
import { fetchEditions } from "@/lib/api";

export function useLanguages() {
  const { data } = useSWR("editions-list", fetchEditions, { revalidateOnFocus: false, refreshInterval: 60000 });
  return data || [];
}

export const LangMenu = ({ lang, onLang, label = "Language", testid = "lang-switch", align = "end" }) => {
  const langs = useLanguages();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = langs.find((l) => l.lang === lang);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid={testid}>
      <button className="lang-menu-btn" onClick={() => setOpen((v) => !v)} aria-haspopup="listbox" aria-expanded={open} title={label} data-testid={`${testid}-button`}>
        <Globe size={14} /> <span dir="auto">{current?.native_name || lang.toUpperCase()}</span> <ChevronDown size={12} style={{ opacity: 0.6 }} />
      </button>
      {open && (
        <ul className="lang-menu" role="listbox" style={{ [align === "end" ? "right" : "left"]: 0 }} data-testid={`${testid}-menu`}>
          {langs.map((l) => (
            <li key={l.lang} role="option" aria-selected={l.lang === lang}>
              <button className={`lang-menu-item ${l.lang === lang ? "on" : ""}`} onClick={() => { onLang(l.lang); setOpen(false); }} data-testid={`${testid}-${l.lang}`}>
                <span className="w-4">{l.lang === lang && <Check size={12} />}</span>
                <span dir="auto" className="flex-1">{l.native_name}</span>
                <span className="text-[10px] uppercase tracking-widest" style={{ opacity: 0.5 }}>{l.name}</span>
                {l.machine_translated && l.review_status !== "approved" && <span className="lang-menu-tag">AI</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
